/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_search_category__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Suche`
};

const en_poi_search_category__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Search`
};

const es_poi_search_category__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Buscar en`
};

const fr_poi_search_category__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Recherche`
};

const it_poi_search_category__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Ricerca`
};

const nl_poi_search_category__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Zoek op`
};

const pt_poi_search_category__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Pesquisar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_search_category__aria_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_search_category__aria_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_search_category__aria_label", locale)
	if (locale === "de") return de_poi_search_category__aria_label(inputs)
	if (locale === "en") return en_poi_search_category__aria_label(inputs)
	if (locale === "es") return es_poi_search_category__aria_label(inputs)
	if (locale === "fr") return fr_poi_search_category__aria_label(inputs)
	if (locale === "it") return it_poi_search_category__aria_label(inputs)
	if (locale === "nl") return nl_poi_search_category__aria_label(inputs)
	return pt_poi_search_category__aria_label(inputs)
};